/* eslint-disable no-var */
import React from 'react';
import { Typography } from '@mui/material';
import { CustomInputField } from '../custom-text-field';

const PrimaryNumericField = React.forwardRef(
  ({
    onChange, onBlur, onFocus, value, name, label, placeholder,
    disabled, startAdornment, min = 0, max, testId = '', decimalAllowed = false,
  }: any, ref) => {
    const onKeyDown = (e:any) => {
      if (e?.code === 'ArrowDown' || e?.code === 'ArrowUp') {
        e.preventDefault();
      }
    };

    const onKeyPress = (e:any) => {
      if (!decimalAllowed && (e.key === '.' || e.key === ',')) {
        e.preventDefault();
      }
      if (e?.key === '-' || e?.key === '+' || e?.key === 'e' || e?.key === 'E') {
        e.preventDefault();
      }
    };

    const onWheel = (e:any) => {
      e.target.blur();
    };

    const onChangeWrapper = (e:any) => {
      let input = e.target.value;

      // Remove leading zeros
      input = input.replace(/^0+/, '');

      if (!decimalAllowed) {
        input = input.replace(/[.,]/g, '');
      }

      if (Number.isNaN(input)) input = '';

      if (input !== '') {
        input = Number(input);
        if (input > max) input = max;
        if (input < min) input = min;
      }

      if (onChange) {
        const updatedEvent = {
          ...e,
          target: { ...e.target, value: input },
        };
        onChange(updatedEvent);
      }
      e.target.value = input;
    };

    const onBlurWrapper = (e:any) => {
      let input = e.target.value;

      if (Number.isNaN(input) || input === '') input = min;

      if (onChange) {
        const updatedEvent = {
          ...e,
          target: { ...e.target, value: input },
        };
        onChange(updatedEvent);
      }

      if (onBlur) {
        const updatedEvent = {
          ...e,
          target: { ...e.target, value: input },
        };
        onBlur(updatedEvent);
      }
      e.target.value = input;
    };

    const inputMode = decimalAllowed ? 'decimal' : 'numeric';
    const step = decimalAllowed ? '0.01' : '1';
    const pattern = decimalAllowed ? '[0-9]*[.,]?[0-9]*' : '[0-9]*';
    return (
      <>
        {label && <Typography variant="body1">{label}</Typography>}

        <CustomInputField
          onChange={onChangeWrapper}
          onBlur={onBlurWrapper}
          onFocus={onFocus ?? undefined}
          onKeyDown={onKeyDown}
          onKeyPress={onKeyPress}
          onWheel={onWheel}
          value={value}
          name={name ?? undefined}
          inputRef={ref ?? undefined}
          size="small"
          placeholder={placeholder ?? undefined}
          fullWidth
          disabled={disabled}
          startAdornment={startAdornment ?? undefined}
          type="number"
          id={`${name}`}
          inputProps={{
            inputMode,
            pattern,
            step,
            min,
            max,
            'data-testid': testId ?? '',
          }}
        />

      </>
    );
  },
);

export default PrimaryNumericField;
